import React from 'react'

interface Legend {
	color: string
	legend_name: string
}

interface MapLegendProps {
	legends: Legend[]
}

const MapLegend = ({legends}: MapLegendProps): React.JSX.Element => (
	<div
		className="-mx-1 inline-flex flex-wrap"
		style={{
			display: 'grid',
			gridAutoFlow: 'column',
			gridAutoColumns: '1fr',
		}}
	>
		{legends.map((legend, index) => (
			<div
				className="m-auto flex flex-col items-center text-center"
				id={`legend${index}`}
				key={`${legend.legend_name}+${legend.color}`}
				style={{margin: '0 5px'}}
			>
				<div
					className="h-6 border border-black"
					style={{backgroundColor: legend.color, width: '100%'}}
				/>
				<p className="mt-0.5 text-xs font-semibold">
					{legend.legend_name}
				</p>
			</div>
		))}
	</div>
)

interface Shape {
	color: string
	legend_name: string
	lower_bound?: number | null
	upper_bound?: number | null
}

interface SidepanelProps {
	subTitle: string
	legends: Shape[]
}

export const MapLegends = ({
	subTitle,
	legends,
}: SidepanelProps): React.JSX.Element => {
	return (
		<div
			className="outline-style: solid container
      inline-flex w-auto rounded-md border-2 border-current bg-white md:items-center"
		>
			<div className="m-3 inline-flex w-auto flex-col">
				<MapLegend legends={legends} />
				<p className="mt-1 text-xs font-semibold">{subTitle}</p>
			</div>
		</div>
	)
}
